import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentPillComponent } from './instrument-pill.component';
import { InstrumentPillService } from './instrument-pill.service';
import { VwdPilldownModule } from '@vwd/vwd-pilldown';
import { I18nPipesModule } from '@vwd/ngx-i18n/pipes';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
      CommonModule,
      VwdPilldownModule,
      I18nPipesModule,
      TranslateModule
  ],
  exports: [
    InstrumentPillComponent
  ],
  declarations: [
      InstrumentPillComponent
  ],
  providers: [
      InstrumentPillService,
  ]
})
export class InstrumentPillModule { }
